module.exports = __webpack_public_path__ + "img/more-dots.a9bb09d9.svg";